module.exports = __webpack_public_path__ + "static/img/2_1_3.4c1635f8.png";